import type { SessionUser } from '@/api/profile/types';
import { apiFetch } from '@/lib/utils/apiFetch';

export async function fetchMe(): Promise<SessionUser | null> {
  try {
    return await apiFetch<SessionUser>('/v3/me');
  } catch {
    return null;
  }
}

export async function patchPreferences(
  key: string,
  value: unknown,
): Promise<void> {
  await apiFetch<void>('/v3/me/preferences', {
    method: 'PATCH',
    body: JSON.stringify([{ key, value }]),
  });
}
